export default __webpack_public_path__ + "static/hsdeville-roman-53c713c7412a7611dd47aa05f649e908.woff2";